import styled from '@emotion/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const ExpandMoreIconStyled = styled(ExpandMoreIcon)`
  fill: rgba(55, 71, 79, 1);

  margin-left: 8px;
`;

export const Autor = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  margin-left: 80px;

  color: #37474f;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const Name = styled.span`
  margin-left: 8px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  color: #37474f;
`;
